/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_5_DescInputs */

const en_mk_loop_5_desc = /** @type {(inputs: Mk_Loop_5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No passing evidence → refused (409). Two failures → the task tier escalates and a stronger model is suggested to the agent.`)
};

const id_mk_loop_5_desc = /** @type {(inputs: Mk_Loop_5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanpa bukti lulus → ditolak (409). Gagal dua kali → tier task naik dan model yang lebih kuat disarankan ke agent.`)
};

/**
* | output |
* | --- |
* | "No passing evidence → refused (409). Two failures → the task tier escalates and a stronger model is suggested to the agent." |
*
* @param {Mk_Loop_5_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_5_desc = /** @type {((inputs?: Mk_Loop_5_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_5_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_5_desc(inputs)
	return en_mk_loop_5_desc(inputs)
});